/**
 * How a captured page is styled once it scrolls for real: in the player's scrollable replay (scrollableReplayHtml in
 * server/capture.ts) and on the Studio canvas (normalizeScroll in src/capture/hotspotAnchor.ts). Both swap the
 * stored page's frozen style (`<style data-ih-replay>`: `html,body{overflow:hidden}` plus the saved scroll as a
 * negative margin) for this. They must use the same one: `body{overflow:hidden}` makes <body> a scroll container
 * that never scrolls, so a `position: sticky` header pinned to it scrolls away with the page instead of sticking.
 */
export const LIVE_REPLAY_CSS = "html{scroll-behavior:auto!important}a[data-ih-href]{cursor:pointer}";

/**
 * The frozen replay and the editor have no scrollbar, so a page there is laid out exactly as wide as the capture's
 * viewport. A scrolling page would show one on platforms with classic scrollbars (Windows, most Linux), narrowing
 * the page by ~15px and moving everything centred, right-aligned or a percentage of its width away from the hotspots
 * drawn over it. Hidden (the page still scrolls), the layout is the same on every platform.
 */
export const HIDE_VIEWPORT_SCROLLBAR_CSS = "html{scrollbar-width:none!important}html::-webkit-scrollbar{display:none!important}";
